import React, { useEffect, useRef, useState } from 'react';

import { timerPhase } from './presentationRules';
import { SmallButton, Timer, TimerActions, TimerLabel } from './styles';

const clock = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;

const PHASE_LABEL = {
  presentation: 'Apresentação da equipe',
  questions: 'Perguntas da banca',
  over: 'Tempo esgotado',
};

interface IPresentationTimerProps {
  /** Reinicia ao trocar de equipe. */
  resetKey: string;
}

/**
 * Cronômetro da banca: 10 min de apresentação e 5 de perguntas (item 4.2.3).
 * A troca de fase muda a cor e é anunciada para leitores de tela.
 */
const PresentationTimer: React.FC<IPresentationTimerProps> = ({ resetKey }) => {
  const [elapsed, setElapsed] = useState(0);
  const [running, setRunning] = useState(false);
  const timer = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    setElapsed(0);
    setRunning(false);
  }, [resetKey]);

  useEffect(() => {
    if (!running) return undefined;
    timer.current = setInterval(() => setElapsed(value => value + 1), 1000);
    return () => clearInterval(timer.current);
  }, [running]);

  const { phase, remaining } = timerPhase(elapsed);

  useEffect(() => {
    if (phase === 'over') setRunning(false);
  }, [phase]);

  return (
    <Timer $phase={phase}>
      <TimerLabel role="status" aria-live="polite">
        {PHASE_LABEL[phase]}
        <strong>{phase === 'over' ? '0:00' : clock(remaining)}</strong>
      </TimerLabel>
      <TimerActions>
        {phase !== 'over' && (
          <SmallButton
            type="button"
            $primary
            onClick={() => setRunning(value => !value)}
          >
            {running ? 'Pausar' : elapsed === 0 ? 'Iniciar' : 'Continuar'}
          </SmallButton>
        )}
        {elapsed > 0 && (
          <SmallButton
            type="button"
            onClick={() => {
              setRunning(false);
              setElapsed(0);
            }}
          >
            Zerar
          </SmallButton>
        )}
      </TimerActions>
    </Timer>
  );
};

export default PresentationTimer;
